import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import LanguageContext from './LanguageContext';
import { termsAndConditionsCopy } from './translations';
import './TermsAndConditions.css';

function TermsAndConditions() {
  const { language } = useContext(LanguageContext);
  const copy = termsAndConditionsCopy[language] || termsAndConditionsCopy.English;

  return (
    <div className="terms-page">
      <div className="terms-container">
        <h1 className="terms-title">{copy.title}</h1>
        <p className="terms-intro">{copy.intro}</p>

        <div className="terms-content">
          <section className="terms-section">
            <div className="section-content">
              <h3 className="section-title">{copy.section1.title}</h3>
              <p className="section-text">{copy.section1.content}</p>
              <p className="section-text">{copy.section1.content2}</p>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-content">
              <h3 className="section-title">{copy.section2.title}</h3>
              <p className="section-text">{copy.section2.content}</p>
              <ul className="terms-list">
                <li>{copy.section2.item1}</li>
                <li>{copy.section2.item2}</li>
                <li>{copy.section2.item3}</li>
              </ul>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-content">
              <h3 className="section-title">{copy.section3.title}</h3>
              <p className="section-text">{copy.section3.content}</p>
              <ul className="terms-list">
                <li>{copy.section3.item1}</li>
                <li>{copy.section3.item2}</li>
                <li>{copy.section3.item3}</li>
              </ul>
              <p className="section-text">{copy.section3.content2}</p>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-content">
              <h3 className="section-title">{copy.section4.title}</h3>
              <p className="section-text">{copy.section4.content}</p>
              <ul className="terms-list">
                <li>{copy.section4.item1}</li>
                <li>{copy.section4.item2}</li>
                <li>{copy.section4.item3}</li>
              </ul>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-content">
              <h3 className="section-title">{copy.section5.title}</h3>
              <p className="section-text">{copy.section5.content}</p>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-content">
              <h3 className="section-title">{copy.section6.title}</h3>
              <p className="section-text">{copy.section6.content}</p>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-content">
              <h3 className="section-title">{copy.section7.title}</h3>
              <p className="section-text">{copy.section7.content}</p>
              <ul className="terms-list">
                <li>{copy.section7.item1}</li>
                <li>{copy.section7.item2}</li>
                <li>{copy.section7.item3}</li>
              </ul>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-content">
              <h3 className="section-title">{copy.section8.title}</h3>
              <p className="section-text">{copy.section8.content}</p>
              <ul className="terms-list">
                <li>{copy.section8.item1}</li>
                <li>{copy.section8.item2}</li>
                <li>{copy.section8.item3}</li>
              </ul>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-content">
              <h3 className="section-title">{copy.section9.title}</h3>
              <p className="section-text">{copy.section9.content}</p>
              <ul className="terms-list">
                <li>{copy.section9.item1}</li>
                <li>{copy.section9.item2}</li>
              </ul>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-content">
              <h3 className="section-title">{copy.section10.title}</h3>
              <p className="section-text">{copy.section10.content}</p>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-content">
              <h3 className="section-title">{copy.section11.title}</h3>
              <p className="section-text">{copy.section11.content}</p>
            </div>
          </section>
        </div>

        <div className="terms-footer">
          <Link to="/" className="back-home-link">
            ← {copy.backHome}
          </Link>
        </div>
      </div>

      {/* Footer Section */}
      <footer className="footer-section">
        <div className="container">
          <div className="footer-content" style={{ textAlign: 'center' }}>
            <div className="footer-column">
              <p style={{ color: '#C7D2FE', marginBottom: '0.5rem' }}>Address: 1st Floor, 124 Cleveland Street, London W1T 6PG</p>
              <p style={{ color: '#C7D2FE', marginBottom: '0.5rem' }}>
                <a href="mailto:manawave@manawave.uk" style={{ color: '#C7D2FE', textDecoration: 'none' }}>manawave@manawave.uk</a>
              </p>
              <p style={{ color: '#C7D2FE', marginBottom: '0.5rem' }}>
                <a href="tel:+447356083797" style={{ color: '#C7D2FE', textDecoration: 'none' }}>+447356083797</a>
              </p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>Copyright © 2026 ManaWave LTD All Rights Reserved</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default TermsAndConditions;
